import {Component, Input} from '@angular/core';
import {TranslocoService} from '@ngneat/transloco';
import {EnumLoginViewMode, IUser} from "../../../interfaces";
import {ToastrService} from "ngx-toastr";
import {AppService, AuthUserService, StoreSelectorsService} from "../../../services";
import {Compbaser} from "../../../components/compbaser";
import {actionEnterpriseRenameResellerUserName, actionEnterpriseRenameResellerUserNameReply} from "../../../store/actions/enterprise.actions";
import {ActionsSubject} from "@ngrx/store";
import {ofType} from "@ngrx/effects";
import {DialogPopComponent} from "../../../components/dialog-pop/dialog-pop.component";
import {MatDialog} from "@angular/material/dialog";
import {timeout} from "../../../decorators/timeout";

@Component({
    selector: 'app-reseller-user-name',
    templateUrl: './change-user-name.component.html',
    styleUrls: ['./change-user-name.component.scss'],

})
export class ChangeUserNameComponent extends Compbaser {
    m_viewMod = EnumLoginViewMode;
    loginName = '';
    m_user: IUser;

    @Input() hideBack = false;

    constructor(private translocoService: TranslocoService,
                private actionsSubj: ActionsSubject,
                private appService: AppService,
                private toastr: ToastrService,
                private storeSelector: StoreSelectorsService,
                private authService: AuthUserService,
                dialog: MatDialog) {
        super(dialog);
        this.cod(
            actionsSubj.pipe(ofType(actionEnterpriseRenameResellerUserNameReply))
                .subscribe((reply) => {
                    if (reply.status === true) {
                        this.toastr.info(this.translocoService.translate('toast.reLogin', {}, this.translocoService.getActiveLang()));
                        setTimeout(() => {
                            this.authService.logout();
                            location.reload();
                        }, 4000);
                    } else {
                        this.toastr.error(this.translocoService.translate('toast.failedRenameUser', {}, this.translocoService.getActiveLang()));
                    }
                })
        );
        this.cod(
            storeSelector.getUser()
                .subscribe((user: IUser) => {
                    this.m_user = user;
                    this.loginName = user.username;
                })
        );
    }

    onChangeUserName() {
        this.loginName = this.loginName.trim();
        if (this.loginName.length < 5)
            return this.toastr.error(this.translocoService.translate('account.nameTooShort', {}, this.translocoService.getActiveLang()));

        const dialogRef = this.dialog.open(DialogPopComponent, {
            height: '200px',
            width: '400px',
            data: {
                name:
                    `${this.translocoService.translate('account.areYouSureThisLogout2', {}, this.translocoService.getActiveLang())}?`,
                showCancel: true
            }
        });
        dialogRef.afterClosed().subscribe((r) => {
            if (r) {
                this.storeSelector.appStore.dispatch(actionEnterpriseRenameResellerUserName({user: this.m_user.username, newUser: this.loginName}));
            }
        });
    }

    @timeout(333)
    logout() {
        this.authService.logout();
        this.appService.goToHomePage(false);
    }

}

